import React, { useState } from "react";
import axios from "axios";
import "../Styling/NewHire.css";
import FormInput from "../Components/FormInput";

function PreJoiningForm() {
  const [formData, setFormData] = useState({
    name: "",
    rank: "",
    dateOfBirth: "",
    nationality: "",
    passportNumber: "",
    passportExpiry: "",
    cdcNumber: "",
    cdcExpiry: "",
    isEligible: false,
    lastCompanyName: "",
    referenceDetails: "",
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent form reload

    console.log("Form Payload:", formData);
  };

  return (
    <>
    <div className="NewHire_container">

     <div className="card">
       <h1>New Hire - Pre-Joining</h1>
       <h6>Capture initial candidate information before induction</h6>
      </div>

      <form>
        <div className="card">
          <h3>Personal & Identity Details</h3>

          <div className="form-row">
            <div className="form-group">
              <FormInput
                label="Full Name"
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                placeholder="Enter full name"
              />
            </div>

            <div className="form-group">
              <FormInput
                label="Rank"
                type="select"
                name="rank"
                value={formData.rank}
                onChange={handleChange}
                placeholder="Select Rank"
                options={[
                  "Captain",
                  "Chief Officer",
                  "Second Officer",
                  "Third Officer",
                  "Chief Engineer",
                ]}
              />
            </div>

            <div className="form-group">
              <FormInput
                label="Date of Birth"
                type="date"
                name="dateOfBirth"
                value={formData.dateOfBirth}
                onChange={handleChange}
                // required={true}
              />
            </div>

            <div className="form-group">
              <FormInput
                label="Nationality"
                type="select"
                name="nationality"
                value={formData.nationality}
                onChange={handleChange}
                placeholder="Select Nationality"
                options={[
                  "Indian",
                  "American",
                  "British",
                  "Canadian",
                  "Australian",
                  "Singaporean",
                  "Filipino",
                  "Chinese",
                  "German",
                  "French",
                ]}
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <FormInput
                label="Passport Number"
                type="text"
                name="passportNumber"
                value={formData.passportNumber}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <FormInput
                label="Passport Expiry"
                type="date"
                name="passportExpiry"
                value={formData.passportExpiry}
                onChange={handleChange}
                // required={true}
              />
            </div>

            <div className="form-group">
              <FormInput
                label="CDC Number"
                type="text"
                name="cdcNumber"
                value={formData.cdcNumber}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <FormInput
                label="CDC Expiry"
                type="date"
                name="cdcExpiry"
                value={formData.cdcExpiry}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

        <div className="card">
          <h3>Induction Eligibility</h3>
          <div className="induction-row">
            <div className="induction-group">
              <input
                type="checkbox"
                id="isEligible"
                name="isEligible"
                checked={formData.isEligible}
                onChange={handleChange}
              />

              <label htmlFor="isEligible">
                All documents valid for induction
              </label>
            </div>
          </div>
        </div>

        <div className="card">
          <h3>Previous Company</h3>

          <div className="Previousform-row">
            <div className="Previousform-group">
              <FormInput
                label="Last Company Name"
                type="text"
                name="lastCompanyName"
                value={formData.lastCompanyName}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <FormInput
                label="Reference Contact Details"
                type="text"
                name="referenceDetails"
                value={formData.referenceDetails}
                onChange={handleChange}
                placeholder="Phone / Email / Notes"
              />
            </div>
          </div>  
        </div>

      </form>
       <div className="NewHire-save-button">
        <button type="submit" className="save-btn">
          Save & Generate Induction Number
        </button>
    </div>
    </div>

   

   </>
  );
}

export default PreJoiningForm;
